export function getLast<T>(arr: T[]): T | undefined {
  return arr[arr.length - 1];
}
export function getLastTwo<T>(arr: T[]): T | undefined {
  return arr[arr.length - 2];
}

const API_BASE = process.env.NODE_ENV == 'development' ?
  (process.env.NEXT_PUBLIC_API_BASE ?? '').replace(/\/+$/, '') : ""; // 뒤 슬래시 제거

export function mediaUrl(path: string | null) {
  if(path == null) return ""
  // path는 '/media/xxx' 또는 'media/xxx' 모두 허용
  const p = path.startsWith('/') ? `${API_BASE}${path}` : `${path}`;
  
  return `${p}`;
} 

export const checkIsStandalone = (): boolean => {
  if (typeof window === "undefined") return false;

  const isDisplayModeStandalone =
    window.matchMedia("(display-mode: standalone)").matches;

  const isIosStandalone =
    (window.navigator as Navigator & {
      standalone?: boolean;
    }).standalone === true;

  return isDisplayModeStandalone || isIosStandalone;
};

/**
 * ### 라틴 스페인어. 
 * - es419 로 지정하면 번역팩이 인식을 못함 왠지 모르겠음
 * - 그래서 es419 => es-419 로 변환 필수
 * - 쿠키 저장 할 때는 기존 es419로 변환
 */
export function transES419(lang: string, reverse?: boolean){
  if(reverse){
    return lang == "es-419" ? "es419" : lang
  }else{
    return lang == "es419" ? "es-419" : lang
  }
}